<template>
  <v-container>
    <h4 class="text-center mt-5">Tabla Variadores</h4>
    <v-simple-table>
      <thead>
        <tr>
          <th v-for="(col, index) in input.customized.tabla.columns" :key="'col-' + index">
            <v-btn class="text-center" color="primary" block>{{ col.text }}</v-btn>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in input.customized.tabla.rows" :key="'row-' + rowIndex">
          <td v-for="(col, colIndex) in row" :key="'cell-' + rowIndex + '-' + colIndex" class="text-center large-font">
            <div v-if="col.tipo === 0">
              -
            </div>
            <div v-if="col.tipo === 1">
              {{ col.label }}
            </div>
            <div v-if="col.tipo === 2">
              <!-- Mostrar el valor cuando está disponible y no es null o undefined -->
              <span v-if="col.value !== null && col.value !== undefined">{{ col.value }}</span>
              <span v-else-if="col.value === 0">0</span>
              <span v-else>No data</span>
            </div>
            <div v-if="col.tipo === 3">
              {{ col.name }}
            </div>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: "KoioteTabla",
  props: {
    input: Object,
  },
  data() {
    return {
      elementosMQTT: [],
      topics: []
    }
  },
  computed: {
    ...mapState("nodered", ["client"])
  },
  mounted() {
    // Extraer los elementos de tipo mqtt
    this.elementosMQTT = this.input.customized.tabla.rows
      .flatMap(fila => fila.filter(elemento => elemento.tipo === 2));

    // Suscribirse a los topics de los elementos MQTT
    this.elementosMQTT.forEach(element => {
      this.doSubscribe(element.topic);
      this.topics = [...new Set([...this.topics, element.topic])];
    });

    // Establecer el manejador de mensajes de MQTT
    this.client.on("message", (topic, message) => {
      // Convertir el mensaje de buffer a string
      const msg = message.toString();
      try {
        // Parsear el mensaje, suponiendo que es un objeto JSON
        const parsedMessage = JSON.parse(msg);
        this.handleMQTTMessage(parsedMessage, topic);
      } catch (e) {
        console.error("Error al procesar el mensaje MQTT:", e);
      }
    });
  },
  methods: {
    ...mapActions("nodered", ["doSubscribe"]), 

    // Este método se invoca cuando se recibe un mensaje MQTT
    handleMQTTMessage(message, topic) {
      if (!this.topics.includes(topic)) {
        console.log(`El topic ${topic} no está en la lista de topics, retornando.`);
        return; // Salir de la función si el topic no está en la lista
      } 

      if (Array.isArray(message)) {
       
        message.forEach(current_message => {
        

          // Busca el elemento en `elementosMQTT` usando topic y name
          const matchingElement = this.elementosMQTT.find(
            element => element.topic === topic && element.name === current_message.name
          );
          if (matchingElement) {
            // Actualiza el valor en el elemento correspondiente
            this.$set(matchingElement, "value", current_message.value);
          } else {
            console.log("No lo he encontrado...");
          }
        });
        console.groupEnd();
      } else if (typeof message === 'object') {
        console.log("Es un objeto");

        // Si el mensaje es un objeto, iteramos sobre sus claves
        Object.keys(message).forEach(key => {
          const current_message = message[key];
          const matchingElement = this.elementosMQTT.find(
            element => element.topic === topic && element.name === current_message.name
          );
          if (matchingElement) {
            console.log("Elemento encontrado:", matchingElement);
            this.$set(matchingElement, "value", current_message.value);
          }
        });
      } else {
        console.log("Mensaje recibido no es un objeto ni un array", typeof message, topic);
      }
    }
  }
};
</script>

<style scoped>
/* Asegurarse de que todo el contenido de las celdas esté centrado y aumentar el tamaño de la fuente */
.text-center {
  text-align: center;
}

.large-font {
  font-size: 24px !important; /* Forzar tamaño de fuente más grande */
  font-weight: bold !important; /* Hacer la fuente más visible */
}
</style>
